/**
 * @module Experience/repdash
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
// core
import { Component, OnInit, OnDestroy, Input, ViewChild, EventEmitter } from '@angular/core';
import { LineSummary } from '@support/api/proxies/responses/api-2006.interface';
import { Line } from '@support/api/proxies/responses/api-2022.interface';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import { RestoreServiceModalComponent } from '@experience/landing/common/components/restore-service-modal/restore-service-modal.component';

import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { Router } from '@angular/router';
import { SUPPORT_LANDING_CONSTANTS } from '@experience/support-landing/constants/support-landing.constants';
import { LINE_LANDING_CONSTANTS } from '@experience/landing/common/components/line-landing/line-landing.constants';
import { KeyValueMap } from '@support/shared/interfaces/key-value-map.interface';
import { PERMISSION_CONSTANTS } from '@support/shared/constants/permission.constants';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';

@Component({
  selector: 'tmo-line-details-tertiary-button',
  templateUrl: './line-details-tertiary-button.component.html',
})
export class LineDetailsTertiaryButtonComponent implements OnInit, OnDestroy {
  /**
   * Variable to hold Line details
   */
  @Input() public lineDetails: LineSummary;
  /**
   * Variable to hold web channel check
   */
  @Input() public isWebChannel: boolean;
  /**
   * Validates whether IMEI is blocked or not.
   */
  @Input() public deviceDetailsLineInformation: Line;
  /**
   * Variable to hold Line Landing constants to be used in html
   */
  @Input() public lineLandingConstants: ConfigData;
  /**
   * configurable data
   */
  @Input() public contentData: ConfigData;

  /**
   *  fraud Lock Indicator
   */
  @Input() public fraudLockIndicator: boolean;
  /**
   * flag to check permission
   */
  public isPermissionAvailable: boolean;
  /**
   * flag to check permission
   */
  public isChangeSimPermission: boolean;
  /**
   * calling restore service modal
   */
  /**
   * stores constant value of Permission Constant
   */
  public permissionConstants: KeyValueMap;
  @ViewChild('restoreServiceModal', { static: false })
  public restoreServiceModal: RestoreServiceModalComponent;
  constructor(
    private stateStoreUtilService: StateStoreUtilsService,
    private featureToggleUtilService: FeatureToggleUtilService,
    private router: Router
  ) {
    this.isPermissionAvailable = true;
    this.isWebChannel = true;
  }

  public ngOnInit(): void {
    this.permissionConstants = PERMISSION_CONSTANTS;
    this.isPermissionAvailable = this.featureToggleUtilService.getFraudLockPermission(
      this.router.url,
      PERMISSION_CONSTANTS.REMOVE_IMEI_BLACKLIST
    );
    this.isChangeSimPermission = this.featureToggleUtilService.getFraudLockPermission(
      this.router.url,
      PERMISSION_CONSTANTS.CHANGE_SIM
    );
    this.isWebChannel = true;
  }
  public ngOnDestroy(): void {}
  /**
   * Function to open Restore Service modal
   * @returns void
   */
  public openRestoreServiceModal(event: EventEmitter<Object>): void {
    this.restoreServiceModal.openRestoreServiceModal(event, this.deviceDetailsLineInformation);
  }
  /**
   * Function to set previous url and navigate to lost device page
   * @returns void
   */
  public navigateToReport(): void {
    this.stateStoreUtilService.setPreviousUrl(LINE_LANDING_CONSTANTS.LINE_LANDING);
    this.router.navigate([SUPPORT_LANDING_CONSTANTS.SUPPORT_LOSTDEVICE_URL]);
  }
}
